import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../services/api";
import { MainLayout } from "../../Layout/MainLayout";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import './CourseDetail.css';

type PieData = {
    name: string;
    value: number;
};

const CourseDetail = () => {
    const navigate = useNavigate()
    const { courseId } = useParams();
    const [dataVideo, setDataVideo] = useState<PieData[]>([]);
    const [dataQuiz, setDataQuiz] = useState<PieData[]>([]);
    const [usersVideoCompleted, setUsersVideoCompleted] = useState<any[]>([])
    const [usersQuizCompleted, setUsersQuizCompleted] = useState<any[]>([])
    const [openVideo, setOpenVideo] = useState(false);
    const [openQuiz, setOpenQuiz] = useState(false);
    const [selectedLegend, setSelectedLegend] = useState("");
    const [courseName, setCourseName] = useState("")
    const [searchBranch, setSearchBranch] = useState('')

    useEffect(() => {
        async function loadData() {
            try {
                const response = await api.get(`/course/${courseId}/users-completed`);

                const {
                    totalUsers,
                    qtdUserCompletedVideo,
                    qtdUserCompletedQuiz,
                    usersVideoCompleted,
                    usersCompletedQuiz
                } = response.data.data;
                setUsersVideoCompleted(usersVideoCompleted)
                setUsersQuizCompleted(usersCompletedQuiz)
                setDataVideo([
                    {
                        name: "Concluíram o vídeo",
                        value: qtdUserCompletedVideo,
                    },
                    {
                        name: "Não concluíram",
                        value: totalUsers - qtdUserCompletedVideo,
                    },
                ]);

                setDataQuiz([
                    {
                        name: "Concluíram o Quiz",
                        value: qtdUserCompletedQuiz,
                    },
                    {
                        name: "Não concluíram",
                        value: totalUsers - qtdUserCompletedQuiz,
                    },
                ]);

            } catch (error) {
                console.error(error);
            }
        }

        async function getName() {
            try {
                const response = await api.get(`/course/${courseId}`);
                setCourseName(response.data.data.title)
            } catch (error) {
                console.error(error);
                return;
            }
        }

        if (courseId) {
            loadData();
            getName();
        }
    }, [courseId]);
    const openModalVideo = (nome: any) => {
        setSelectedLegend(nome);
        setOpenVideo(true);
    };

    const openModalQuiz = (nome: any) => {
        setSelectedLegend(nome);
        setOpenQuiz(true);
    };

    const COLORS = [
        "#00fe3f",
        "#ff4f42",
    ];

    async function handleExportClick(courseId: string) {
        try {
            const res = await api.get(`/course/${courseId}/export`, { responseType: 'blob' })

            const url = window.URL.createObjectURL(new Blob([res.data]))
            const a = document.createElement('a')
            a.href = url
            a.download = `conclusoes_curso_${courseName}.xlsx`
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error('Erro ao exportar planilha:', error)
            alert('Erro ao gerar a planilha. Tente novamente.')
        }
    }

    const userVideoFiltred = usersVideoCompleted.filter(user =>
        user.user.branch.code.toLowerCase().includes(searchBranch.toLowerCase()) ||
        user.user.cpf.toLowerCase().includes(searchBranch.toLowerCase())
    )
    const userQuizFiltred = usersQuizCompleted.filter(user =>
        user.user.branch.code.toLowerCase().includes(searchBranch.toLowerCase()) ||
        user.user.cpf.toLowerCase().includes(searchBranch.toLowerCase())
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/catalogo')}>Biblioteca</a>
                    <span className="sep">›</span>
                    <a onClick={() => navigate('/admin')}>Painel</a>
                    <span className="sep">›</span>
                    <span>Detalhes do Curso</span>
                </div>
                <div className="container">
                    <button className="download-btn" onClick={() => handleExportClick(courseId as string)}> Exportar</button>
                </div>
                <div style={{
                    display: "flex",
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginTop: "150px"
                }}>
                    {/* Gráfico Vídeo */}
                    <div style={{ width: "450px", height: "400px" }}>
                        <h2 style={{ textAlign: "center" }}>
                            Conclusão dos vídeos
                        </h2>

                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={dataVideo}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={130}
                                    label
                                >
                                    {dataVideo.map((_, index) => (
                                        <Cell
                                            key={index}
                                            fill={COLORS[index]}
                                        />
                                    ))}
                                </Pie>

                                <Tooltip />
                                <Legend
                                    onClick={(item) => openModalVideo(item.value)}
                                    wrapperStyle={{ cursor: "pointer" }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>


                    {/* Gráfico Quiz */}
                    <div style={{ width: "450px", height: "400px" }}>
                        <h2 style={{ textAlign: "center" }}>
                            Conclusão dos Quizzes
                        </h2>

                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={dataQuiz}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={130}
                                    label
                                >
                                    {dataQuiz.map((_, index) => (
                                        <Cell
                                            key={index}
                                            fill={COLORS[index]}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend
                                    onClick={(item) => openModalQuiz(item.value)}
                                    wrapperStyle={{ cursor: "pointer" }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>

                </div>
            </div>
            {openVideo && (
                <div className="modal-overlay" onClick={() => setOpenVideo(false)}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-header">
                            <h2>{selectedLegend}</h2>
                            <button
                                className="modal-close"
                                onClick={() => { setOpenVideo(false); setSearchBranch('') }}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="modal-body">
                            <input
                                type="text"
                                className="search-filial"
                                placeholder="Buscar por Filial ou CPF"
                                value={searchBranch}
                                onChange={(e) => setSearchBranch(e.target.value)}
                            />
                            <div className="table-scroll">
                                <table className="cu-table">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>CPF</th>
                                            <th>Filial</th>
                                            <th>Data Visualização</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {userVideoFiltred.map(user => (
                                            <tr key={user.id}>
                                                <td data-label="Nome">{user.user.name}</td>
                                                <td data-label="Nome">{user.user.cpf}</td>
                                                <td data-label="Nome">{user.user.branch.code}</td>
                                                <td data-label="Data Visualização">
                                                    {new Date(user.lastView).toLocaleDateString('pt-BR')}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {openQuiz && (
                <div className="modal-overlay" onClick={() => setOpenQuiz(false)}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-header">
                            <h2>{selectedLegend}</h2>
                            <button
                                className="modal-close"
                                onClick={() => { setOpenQuiz(false); setSearchBranch('') }}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="modal-body">
                            <input
                                type="text"
                                className="search-filial"
                                placeholder="Buscar por Filial ou CPF"
                                value={searchBranch}
                                onChange={(e) => setSearchBranch(e.target.value)}
                            />
                            <div className="table-scroll">
                                <table className="cu-table">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>CPF</th>
                                            <th>Filial</th>
                                            <th>Data Conclusão</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {userQuizFiltred.map(user => (
                                            <tr key={user.id}>
                                                <td data-label="Nome">{user.user.name}</td>
                                                <td data-label="Nome">{user.user.cpf}</td>
                                                <td data-label="Nome">{user.user.branch.code}</td>
                                                <td data-label="Data Conclusão">
                                                    {new Date(user.completedIn).toLocaleDateString('pt-BR')}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </MainLayout>
    );
};

export default CourseDetail;